import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import './AdminLayout.css';

const TABS = [
    { to: '/admin/reports', label: 'Жалобы' },
    { to: '/admin/ads', label: 'Объявления' },
    { to: '/admin/import', label: 'Импорт' },
    { to: '/admin/comments', label: 'Комментарии' },
    { to: '/admin/users', label: 'Пользователи' },
    { to: '/admin/news', label: 'Новости' },
    { to: '/admin/articles', label: 'Статьи' },
    { to: '/admin/useful-links', label: 'Полезные ссылки' },
];

const AdminLayout = () => {
    return (
        <div className="admin-layout">
            <div className="admin-layout__tabs">
                {TABS.map(tab => (
                    <NavLink
                        key={tab.to}
                        to={tab.to}
                        className={({ isActive }) => `admin-layout__tab ${isActive ? 'admin-layout__tab--active' : ''}`}
                    >
                        {tab.label}
                    </NavLink>
                ))}
            </div>
            <Outlet />
        </div>
    );
};

export default AdminLayout;
